class CollectionDescription extends HTMLElement {
  MAX_LENGTH = 500;
  SHOW_MORE = true;
  constructor() {
    super();
    this.descriptionFull = this.innerHTML;

    if (this.getAttribute("show-more") === "false") {
      this.SHOW_MORE = false;
    }

    if (this.getAttribute("max-length")) {
      this.MAX_LENGTH = parseInt(this.getAttribute("max-length"));
    }

    if (this.innerText.length > this.MAX_LENGTH) {
      // truncate text
      this.descriptionClipped = window.textClipper(
        this.descriptionFull,
        this.MAX_LENGTH,
        { html: true }
      );

      // replace original content with cropped desc
      this.innerHTML = this.descriptionClipped;

      if (this.SHOW_MORE) {
        // add show more button
        const showMoreBtn = `<div class="btn-container">
          <a class="readmore" href="#full-description">Voir plus></a>
        </div>`;
        this.innerHTML += showMoreBtn;
      }

      // remove processing class
      this.classList.remove("processing");

      // move original description to bottom
      if (this.SHOW_MORE) {
        const bottomDescContainer = document.getElementById("full-description");

        bottomDescContainer.innerHTML = this.descriptionFull;
      }
    }
  }
}

customElements.define("collection-description", CollectionDescription);
